import { inject, view } from "@spawn/core";
import { TeaserAddon } from "@spawn/slot-machine";
import { first } from "rxjs";
import { NudgeUpService } from "../services/nudgeUpService";

/**
 * As opposed to the regular teaser addon, for nudging mysteries we only want to play the teaser animation once
 * they first land on the reelset and not on every nudge.
 */
@view
export class MysteryTeaserAddon extends TeaserAddon {
	@inject protected readonly nudgeUpService!: NudgeUpService;

	// mostly copied but changed the condition
	public override onReelBounce(): Promise<void> {
		return new Promise<void>((resolve) => {
			const slotFace = this.reelController.getSlotFace(undefined, this.options.networkStatePath);

			if (slotFace[this.reelIndex].includes(this.options.symbolId) && this.isNewlyArrivedMystery()) {
				this.symbolView.hideTexture();
				this.teaserAnimation.skinName = this.options.skinName ?? this.options.animationName;
				this.teaserAnimation._pixiObject.update(0);

				this.teaserAnimation.play(this.options.animationName);
				this.teaserAnimation.visible = true;

				// eslint-disable-next-line @spawn/unmanaged-rxjs-subscription
				this.teaserAnimation.finished$.pipe(first()).subscribe(async () => {
					await this.gameTime.waitForNextTick();
					this.teaserAnimation.visible = false;
					this.symbolView.showTexture();
					resolve();
				});
			} else {
				resolve();
			}
		});
	}

	protected isNewlyArrivedMystery(): boolean {
		return this.nudgeUpService.reelsWithNewMysteries[this.symbolView.reelView.reelIndex] > 0;
	}

	protected override playTeaserSound(_countUntilThisReel: number): void {
		// sound is played once on reel level, not per symbol (reelTeaserAddon)
	}
}
